import { useCallback, useEffect } from 'react';
import pxToRem from '../../util/pxToRem';
var moduloColumns = function (columns, modulo) {
    return Math.floor(columns / modulo) * modulo;
};
export var calcColumns = function (_a) {
    var minWidth = _a.minWidth, elementWidth = _a.elementWidth, gap = _a.gap, modulo = _a.modulo, maxColumns = _a.maxColumns, _b = _a.scrollHint, scrollHint = _b === void 0 ? 0 : _b;
    var gapSize = parseFloat(gap);
    var elementWidthInRem = pxToRem(elementWidth);
    var columns = Math.min(Math.floor((elementWidthInRem + gapSize - minWidth * scrollHint) /
        (minWidth + gapSize)), maxColumns);
    return Math.max(1, moduloColumns(columns, modulo));
};
export var useScrollToKeyboardFocus = function (ref, scroll) {
    var scrollToFocused = useCallback(function (keyboardEvent) {
        var target = keyboardEvent.target;
        if (target instanceof HTMLElement &&
            scroll &&
            keyboardEvent.key === 'Tab') {
            target.scrollIntoView({
                inline: 'center',
                block: 'nearest',
                behavior: 'smooth'
            });
        }
    }, [scroll]);
    useEffect(function () {
        ref.current.addEventListener('keyup', scrollToFocused);
        return function () {
            ref.current && ref.current.removeEventListener('keyup', scrollToFocused);
        };
    }, [scrollToFocused, ref]);
};
